import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-step-four',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './step-four.component.html',
  styleUrls: ['./step-four.component.scss']
})
export class StepFourComponent {
  @Input() seguroOption: string = '';
  @Output() seguroChange = new EventEmitter<string>();

  onSeguroChange(value: string) {
    this.seguroChange.emit(value);
  }
} 